<div class="modal-header">
  <h3>
    {{ TradeCategory && TradeCategory.id ? 'Edit' : 'Add' }} Trade Category
  </h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close('Cross Click')"
  ></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col">
      <form [formGroup]="tradeCategoryForm">
        <div class="row g-3">
          <div class="col">
            <div class="form-group">
              <label for="name" class="form-label" requiredAsterisk
                >Category Name</label
              >
              <input
                id="name"
                type="text"
                class="form-control"
                formControlName="categoryName"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="row w-100 justify-content-end">
    <div class="col-3">
      <button class="btn btn-danger" (click)="close('Close')">Close</button>
    </div>
    <div class="col-3">
      <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
  </div>
</div>
